import { cn } from "@/lib/utils"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"

interface NavigationItemProps extends React.ComponentPropsWithoutRef<"a"> {
  active?: boolean
}

export const NavigationItem: React.FC<NavigationItemProps> = ({
  children,
  href = "/",
  className,
  active,
  ...props
}) => (
  <LocalizedClientLink
    href={href}
    className={cn(
      "label-md px-4 py-3 my-3 md:my-0 flex items-center justify-between font-medium text-[#8C8C8C]",
      active && "text-[#1A1A1A]",
      className
    )}
    {...props}
  >
    {children}
  </LocalizedClientLink>
)
